module.exports = __webpack_public_path__ + "media/images/brand/favicon-09-ccc16e76efb3ca21c4de7b4c838bcfba.png";